import { useEffect, useRef } from 'react';

type UseSetValidity = {
  hasTouched?: boolean;
  isValid?: boolean;
  errorMessage?: string;
};

export const useSetValidity = ({ hasTouched, isValid, errorMessage }: UseSetValidity) => {
  const $fieldElement = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if ($fieldElement.current) {
      $fieldElement.current.setCustomValidity(
        isValid ? '' : (errorMessage ?? 'This field is invalid'),
      );
      if (hasTouched && !isValid)
        $fieldElement.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [isValid, errorMessage, $fieldElement.current]);

  return $fieldElement;
};
